/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedThresholdsRouteImport } from './routes/_authenticated/thresholds'
import { Route as AuthenticatedGroupsRouteImport } from './routes/_authenticated/groups'
import { Route as AuthenticatedChangeLogRouteImport } from './routes/_authenticated/change-log'
import { Route as AuthenticatedAnnotationsRouteImport } from './routes/_authenticated/annotations'
import { Route as AuthenticatedAlertsRouteImport } from './routes/_authenticated/alerts'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedSiteSlugWorkbenchRouteImport } from './routes/_authenticated/$siteSlug/workbench'
import { Route as AuthenticatedSiteSlugMapRouteImport } from './routes/_authenticated/$siteSlug/map'
import { Route as AuthenticatedSiteSlugGraphRouteImport } from './routes/_authenticated/$siteSlug/graph'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedThresholdsRoute = AuthenticatedThresholdsRouteImport.update({
  id: '/thresholds',
  path: '/thresholds',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGroupsRoute = AuthenticatedGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChangeLogRoute = AuthenticatedChangeLogRouteImport.update({
  id: '/change-log',
  path: '/change-log',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAnnotationsRoute =
  AuthenticatedAnnotationsRouteImport.update({
    id: '/annotations',
    path: '/annotations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAlertsRoute = AuthenticatedAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSiteSlugWorkbenchRoute =
  AuthenticatedSiteSlugWorkbenchRouteImport.update({
    id: '/$siteSlug/workbench',
    path: '/$siteSlug/workbench',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSiteSlugMapRoute =
  AuthenticatedSiteSlugMapRouteImport.update({
    id: '/$siteSlug/map',
    path: '/$siteSlug/map',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSiteSlugGraphRoute =
  AuthenticatedSiteSlugGraphRouteImport.update({
    id: '/$siteSlug/graph',
    path: '/$siteSlug/graph',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/alerts': typeof AuthenticatedAlertsRoute
  '/annotations': typeof AuthenticatedAnnotationsRoute
  '/change-log': typeof AuthenticatedChangeLogRoute
  '/groups': typeof AuthenticatedGroupsRoute
  '/thresholds': typeof AuthenticatedThresholdsRoute
  '/users': typeof AuthenticatedUsersRoute
  '/$siteSlug/graph': typeof AuthenticatedSiteSlugGraphRoute
  '/$siteSlug/map': typeof AuthenticatedSiteSlugMapRoute
  '/$siteSlug/workbench': typeof AuthenticatedSiteSlugWorkbenchRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/alerts': typeof AuthenticatedAlertsRoute
  '/annotations': typeof AuthenticatedAnnotationsRoute
  '/change-log': typeof AuthenticatedChangeLogRoute
  '/groups': typeof AuthenticatedGroupsRoute
  '/thresholds': typeof AuthenticatedThresholdsRoute
  '/users': typeof AuthenticatedUsersRoute
  '/': typeof AuthenticatedIndexRoute
  '/$siteSlug/graph': typeof AuthenticatedSiteSlugGraphRoute
  '/$siteSlug/map': typeof AuthenticatedSiteSlugMapRoute
  '/$siteSlug/workbench': typeof AuthenticatedSiteSlugWorkbenchRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/account': typeof AuthenticatedAccountRoute
  '/_authenticated/alerts': typeof AuthenticatedAlertsRoute
  '/_authenticated/annotations': typeof AuthenticatedAnnotationsRoute
  '/_authenticated/change-log': typeof AuthenticatedChangeLogRoute
  '/_authenticated/groups': typeof AuthenticatedGroupsRoute
  '/_authenticated/thresholds': typeof AuthenticatedThresholdsRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$siteSlug/graph': typeof AuthenticatedSiteSlugGraphRoute
  '/_authenticated/$siteSlug/map': typeof AuthenticatedSiteSlugMapRoute
  '/_authenticated/$siteSlug/workbench': typeof AuthenticatedSiteSlugWorkbenchRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/account'
    | '/alerts'
    | '/annotations'
    | '/change-log'
    | '/groups'
    | '/thresholds'
    | '/users'
    | '/$siteSlug/graph'
    | '/$siteSlug/map'
    | '/$siteSlug/workbench'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/account'
    | '/alerts'
    | '/annotations'
    | '/change-log'
    | '/groups'
    | '/thresholds'
    | '/users'
    | '/'
    | '/$siteSlug/graph'
    | '/$siteSlug/map'
    | '/$siteSlug/workbench'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/account'
    | '/_authenticated/alerts'
    | '/_authenticated/annotations'
    | '/_authenticated/change-log'
    | '/_authenticated/groups'
    | '/_authenticated/thresholds'
    | '/_authenticated/users'
    | '/_authenticated/'
    | '/_authenticated/$siteSlug/graph'
    | '/_authenticated/$siteSlug/map'
    | '/_authenticated/$siteSlug/workbench'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/thresholds': {
      id: '/_authenticated/thresholds'
      path: '/thresholds'
      fullPath: '/thresholds'
      preLoaderRoute: typeof AuthenticatedThresholdsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groups': {
      id: '/_authenticated/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AuthenticatedGroupsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/change-log': {
      id: '/_authenticated/change-log'
      path: '/change-log'
      fullPath: '/change-log'
      preLoaderRoute: typeof AuthenticatedChangeLogRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/annotations': {
      id: '/_authenticated/annotations'
      path: '/annotations'
      fullPath: '/annotations'
      preLoaderRoute: typeof AuthenticatedAnnotationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/alerts': {
      id: '/_authenticated/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AuthenticatedAlertsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$siteSlug/workbench': {
      id: '/_authenticated/$siteSlug/workbench'
      path: '/$siteSlug/workbench'
      fullPath: '/$siteSlug/workbench'
      preLoaderRoute: typeof AuthenticatedSiteSlugWorkbenchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$siteSlug/map': {
      id: '/_authenticated/$siteSlug/map'
      path: '/$siteSlug/map'
      fullPath: '/$siteSlug/map'
      preLoaderRoute: typeof AuthenticatedSiteSlugMapRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$siteSlug/graph': {
      id: '/_authenticated/$siteSlug/graph'
      path: '/$siteSlug/graph'
      fullPath: '/$siteSlug/graph'
      preLoaderRoute: typeof AuthenticatedSiteSlugGraphRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedAlertsRoute: typeof AuthenticatedAlertsRoute
  AuthenticatedAnnotationsRoute: typeof AuthenticatedAnnotationsRoute
  AuthenticatedChangeLogRoute: typeof AuthenticatedChangeLogRoute
  AuthenticatedGroupsRoute: typeof AuthenticatedGroupsRoute
  AuthenticatedThresholdsRoute: typeof AuthenticatedThresholdsRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedSiteSlugGraphRoute: typeof AuthenticatedSiteSlugGraphRoute
  AuthenticatedSiteSlugMapRoute: typeof AuthenticatedSiteSlugMapRoute
  AuthenticatedSiteSlugWorkbenchRoute: typeof AuthenticatedSiteSlugWorkbenchRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedAlertsRoute: AuthenticatedAlertsRoute,
  AuthenticatedAnnotationsRoute: AuthenticatedAnnotationsRoute,
  AuthenticatedChangeLogRoute: AuthenticatedChangeLogRoute,
  AuthenticatedGroupsRoute: AuthenticatedGroupsRoute,
  AuthenticatedThresholdsRoute: AuthenticatedThresholdsRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedSiteSlugGraphRoute: AuthenticatedSiteSlugGraphRoute,
  AuthenticatedSiteSlugMapRoute: AuthenticatedSiteSlugMapRoute,
  AuthenticatedSiteSlugWorkbenchRoute: AuthenticatedSiteSlugWorkbenchRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
